// import { useModulePermission } from 'src/hooks/use-module-permission';
import { m } from 'framer-motion';

import Container from '@mui/material/Container';
import { Box, Button, Typography } from '@mui/material'; // Exemplo de tela de bloqueio

import {
  GetStoreModulePermissionsQuery,
  useGetStoreModulePermissionsQuery,
} from 'src/graphql/generated';

import Iconify from 'src/components/iconify';
import { LoadingScreen } from 'src/components/loading-screen';
import { varBounce, MotionContainer } from 'src/components/animate';

type PremiumGuardProps = {
  children: React.ReactNode;
  permissionKey: keyof NonNullable<GetStoreModulePermissionsQuery['getStoreModulePermissions']>;
};

const PREMIUM_SUPPORT_WHATSAPP_URL =
  'https://api.whatsapp.com/send/?phone=5511971048980&text=Ol%20gostaria%20de%20adquirir%20funcionalidade%20premium';

export default function PremiumGuard({ children, permissionKey }: PremiumGuardProps) {
  const { data: modulePermissionsData, loading } = useGetStoreModulePermissionsQuery();

  if (loading) return <LoadingScreen />;

  const modulePermissions = modulePermissionsData?.getStoreModulePermissions;
  const hasPermission = Boolean(modulePermissions?.[permissionKey]);

  if (hasPermission) {
    return <>{children}</>;
  }

  return (
    <Container component={MotionContainer} sx={{ textAlign: 'center', padding: '2rem' }}>
      <m.div variants={varBounce().in}>
        <Box
          component="img"
          alt="premium"
          src="/assets/icons/premium/crown-simple-fill.svg"
          sx={{ width: 44, height: 44, mb: 2 }}
        />
        <Typography variant="h4" gutterBottom>
          Funcionalidade Premium
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary' }}>
          Entre em contato com o Suporte para fazer Upgrade.
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Button
          variant="contained"
          color="success"
          sx={{ mt: 3 }}
          startIcon={<Iconify icon="mdi:whatsapp" />}
          href={PREMIUM_SUPPORT_WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Falar com Suporte
        </Button>
      </m.div>
    </Container>
  );
}

export function PremiumGuardFilter({ children, permissionKey }: PremiumGuardProps) {
  const { data: modulePermissionsData } = useGetStoreModulePermissionsQuery();

  const modulePermissions = modulePermissionsData?.getStoreModulePermissions;
  const hasPermission = Boolean(modulePermissions?.[permissionKey]);

  if (hasPermission) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        borderRadius: '0.5rem',
        border: '1px dashed #00000068',
      }}
    >
      <Box
        component="img"
        alt="premium"
        src="/assets/icons/premium/crown-simple-fill.svg"
        sx={{ width: 24, height: 24, mb: 1 }}
      />
      <Typography variant="subtitle2" gutterBottom>
        Funcionalidade Premium
      </Typography>
    </Box>
  );
}
